import { render, staticRenderFns } from "./ClassroomTable.vue?vue&type=template&id=45d2183e&scoped=true"
import script from "./ClassroomTable.vue?vue&type=script&lang=js"
export * from "./ClassroomTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2183e",
  null
  
)

export default component.exports